import { render, staticRenderFns } from "./TestVentaInfoModal.vue?vue&type=template&id=50c9f86e"
import script from "./TestVentaInfoModal.vue?vue&type=script&lang=js"
export * from "./TestVentaInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports